import { MenuOptions } from 'models';
import { MenuItem, MenuItemWithClick, StyledBadge } from './NavMenuItem.styles';

interface MenuItemProps {
  option: MenuOptions;
  totalVouchers: number;
  hasNewVouchers: boolean;
}

const NavMenuItem = ({
  option: { path, label, icon: Icon, onClick, iconProps, showBadge },
  totalVouchers,
  hasNewVouchers,
}: MenuItemProps) => {
  const Item = onClick ? MenuItemWithClick : MenuItem;
  const color = hasNewVouchers ? 'secondary' : 'primary';

  const ListItem = () => (
    <Item to={path} onClick={onClick} key={label}>
      <Icon {...iconProps} />
      {label}
    </Item>
  );

  if (showBadge) {
    return (
      <StyledBadge color={color} badgeContent={totalVouchers}>
        <ListItem />
      </StyledBadge>
    );
  }

  return <ListItem />;
};

export default NavMenuItem;
